import imageByAdd1 from "../../assets/bg_add_1.png";
import { Link } from "react-router-dom";

const Landing = () => {
  return (
    <div className="flex flex-col h-90vh justify-end pb-48">
      <h1 className="font-inter font-bold text-main-black text-6xl w-3/6 animate-slideTop">
        Controle as suas finanças com facilidade.
      </h1>
      <p className="font-inter font-light mt-8 text-light-black text-lg w-2/6 animate-slideTop">
        Organize as suas despesas, poupe mais e alcance os seus objetivos
        financeiros com o cashtracker.
      </p>
      <Link to="/login" className="mt-12 w-32 rounded-full">
        <button className="font-inter w-32 py-2 rounded-full text-main-white hover:bg-light-black bg-main-black animate-slideTop">
          Começar
        </button>
      </Link>
      <img
        draggable="false"
        className="fixed -top-2/4 -right-1/4 animate-slideDiagonalTop -z-10"
        src={imageByAdd1}
        alt="background add"
      ></img>
    </div>
  );
};

export default Landing;
